import React from 'react';
import styles from './DimmingMini.module.scss';

export interface DimmingMiniProps {
  value: number | null | undefined;
  tooltip?: string;
}

function getDimmingColor(value: number): string {
  if (value <= 0) return '#dc2626';
  if (value <= 10) return '#eab308';
  if (value <= 40) return '#22c55e';
  return '#059669';
}

export default function DimmingMini({ value, tooltip }: DimmingMiniProps) {
  const isNA = value === null || value === undefined || Number.isNaN(value);
  const color = isNA ? '#d1d5db' : getDimmingColor(value as number);
  const formatted = isNA ? 'NA' : Math.round(value as number).toString();

  return (
    <div className={styles.container} title={tooltip}>
      <span className={styles.value} style={{ color }}>
        {formatted}
      </span>
      {!isNA && (
        <span className={styles.unit} style={{ color }}>
          {' '}%
        </span>
      )}
    </div>
  );
}
